import React, {Component} from "react"
import * as PropTypes from "prop-types"

import {FormattedMessage} from "@irati/utils/lang"
import {RouterLink} from "@irati/ui/src/Link"
import {Para} from "@irati/ui/src/Labels"
import Button from "@irati/ui/src/Button"
import authentication from "@irati/auth"

import {GhostActionsArea} from "./styled"

class GhostAdmin extends Component {
  static contextTypes = {
    apps: PropTypes.object.isRequired
  }

  render() {
    const {apps: contextApps} = this.context
    const isGhostUser = authentication.isUserGhost()
    if (!isGhostUser) return null

    return (
      <GhostActionsArea>
        <Para large>
          <FormattedMessage id="setup_tenant.ghostActions.title" />
        </Para>
        <RouterLink primary to="/" app={contextApps.ADMIN}>
          <Button primary>
            <FormattedMessage id="platform.header.adminButton.admin" />
          </Button>
        </RouterLink>
      </GhostActionsArea>
    )
  }
}

export default GhostAdmin
